import { render, staticRenderFns } from "./PlanProposalDetails.vue?vue&type=template&id=623e3bd5&"
import script from "./PlanProposalDetails.vue?vue&type=script&lang=js&"
export * from "./PlanProposalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports